(() => {
  const lang = (document.documentElement.lang || '').toLowerCase();
  if (!lang.startsWith('zh')) return;

  const translations = new Map([
    ['Reload cart', '重新載入購物車'],
    ["Couldn't update cart. Try again.", '無法更新購物車，請再試一次。'],
    ['Reload cart to confirm total.', '重新載入購物車以確認總額。'],
  ]);

  const cartRootSelector = 'cart-drawer, cart-items, #CartDrawer, #main-cart-items, #MainCartItems, .cart__footer';

  function translateText(root) {
    const scope = root?.nodeType === Node.ELEMENT_NODE ? root : document.body;
    if (!scope) return;

    const roots = scope.matches?.(cartRootSelector)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(cartRootSelector) || []);

    roots.forEach((cartRoot) => {
      const walker = document.createTreeWalker(cartRoot, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const original = node.nodeValue;
        const trimmed = original?.trim();
        const translated = translations.get(trimmed);
        if (!translated) continue;
        node.nodeValue = original.replace(trimmed, translated);
      }
    });
  }

  const start = () => {
    translateText(document.body);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          translateText(mutation.target.parentElement);
          return;
        }
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) translateText(node);
          else if (node.parentElement) translateText(node.parentElement);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
